import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Header from '../Header/header'
import Banner from './Banner/banner'
import DocAbout from './doc_about/docAbout'
import Chooseus from './chooseus/chooseus'
import Steps from './steps/steps'
// import Makeappointment from './make_appointment/makeappointment';
import Gallery from './Gallery/Gallery'
import Testimonial from './testimonial/testimonial'
import Whatsapp from '../Whatsapp/Whatsapp'
import { Helmet } from 'react-helmet'

const Home = () => {
  const { appoint } = useParams()

  useEffect(() => {
    const targetSection = document.getElementById(appoint)
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: 'smooth' })
    }
  }, [appoint])

  return (
    <div>
      <Helmet>
        <title>Best Skin Care Clinic in Pitampura | Sharva Clinique</title>
        <meta property='og:title' content='Best Skin Care Clinic in Pitampura | Sharva Clinique' />
        <meta property='og:url' content='https://sharvaclinique.com/' />
        <meta
          name='description'
          content='Looking for the best skin care clinic in Pitampura? Get advanced acne, pigmentation & anti-aging treatments by experienced skin specialists. Book now.'
        />
      </Helmet>
      <Header />
      <Banner />
      <DocAbout />
      <Chooseus />
      <Steps />
      {/* <Makeappointment/> */}
      <Gallery />
      <Testimonial />
      <Whatsapp />
    </div>
  )
}

export default Home
